export default "__VITE_ASSET__cf04ef26__"